export const API_BASE = (process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000/api').replace(/\/$/, '');
export const API_BASE_URL = API_BASE;

export const SAVE_CONTACT_URL = `${API_BASE}/contacts`;
export const Update_CONTACT_URL = (id) => `${API_BASE}/contacts/${id}`;
// Add more endpoints if needed
export const GET_CONTACTS_URL = `${API_BASE}/adsdsdsdsd`;

export const LAST_7_DAYS_URL = `${API_BASE}/performance/last-7-days`;
export const CASE_STATUS_MIX_URL = `${API_BASE}/performance/case-status-mix`;

export default {
  API_BASE,
  API_BASE_URL,
  SAVE_CONTACT_URL,
  GET_CONTACTS_URL,
  Update_CONTACT_URL,
  LAST_7_DAYS_URL,
  CASE_STATUS_MIX_URL,
};
